import { LucideIcon, Layers, Database, Shield, Zap, Eye, Rocket, GraduationCap } from 'lucide-react'

export interface Service {
    id: string
    title: string
    description: string
    icon: LucideIcon
    image?: string  // Caminho da imagem do serviço
}

export const services: Service[] = [
    {
        id: 'arquitetura-aplicacoes',
        title: 'Arquitetura de Aplicações',
        // description: 'Mapeamos seus sistemas existentes e propomos uma arquitetura alvo detalhada. Definimos integrações e padrões necessários, garantindo aderência ao legado, segurança, observabilidade, conectividade, escalabilidade e a velocidade exigida pelo negócio.',
        description: 'Mapeamos o legado e desenhamos a arquitetura alvo. Definimos integrações e padrões para garantir escalabilidade, segurança e a velocidade que o negócio exige.',
        icon: Layers,
        image: '/assets/desenvolvedora-mobile-construindo-app-ab-testing-cloud-code-alinhado-direita.svg',
    },
    {
        id: 'arquitetura-dados',
        title: 'Arquitetura de Dados',
        // description: 'Identificamos a aplicabilidade dos seus dados (estruturados, semiestruturados ou desestruturados). Avaliamos a melhor maneira de operacionalizar integrações para gerar informação estratégica e conhecimento real para a sua tomada de decisão.',
        description: 'Transformamos dados brutos em inteligência. Definimos a melhor estratégia para integrar e operacionalizar seus dados, gerando conhecimento real para tomada de decisão.',
        icon: Database,
        image: '/assets/busca.jpg',
    },
    {
        id: 'governanca-ti',
        title: 'Governança de TI',
        description: 'Integramos a tecnologia ao core business. Implementamos práticas recomendadas como comitês formais, gestão de riscos e alinhamento estratégico para garantir transparência, prestação de contas e fomento à inovação responsável.',
        icon: Shield,
        image: '/assets/gov.jpg',
    },
    {
        id: 'arquitetura-agil',
        title: 'Arquitetura Ágil',
        description: 'Mapeamos a maturidade Ágil da sua empresa e propomos metodologias adaptadas ao seu cenário. Visamos uma estratégia enxuta, eliminando desperdícios e agregando valor contínuo ao cliente.',
        icon: Zap,
        image: '/assets/squad-clean.jpg',
    },
    {
        id: 'observabilidade',
        title: 'Observabilidade',
        description: 'Padronizamos a visão sobre seus produtos através de modelagem de log analytics. Criamos KPIs de TI e de negócio para identificação de débitos técnicos e endereçamento preciso às squads.',
        icon: Eye,
        image: '/assets/observabilidade.jpg',
    },
    {
        id: 'devops',
        title: 'DevOps',
        description: 'Apoiamos na construção de processos e cultura DevSecOps para diminuir o time-to-market. Padronizamos ambientes e pipelines para entrega contínua.',
        icon: Rocket,
        image: '/assets/sre.png',
    },
    {
        id: 'profissionalizacao-ti',
        title: 'Profissionalização da TI',
        // description: 'Entendemos o momento atual da TI e alinhamos as metas junto com as lideranças. Ajudamos a definir processos, padrões e ferramental para o amadurecimento da área, implantando Governança de Projetos e disciplinas essenciais: Administração de Dados, QA, SRE e UX.',
        description: 'Evoluímos a maturidade da sua TI. Implantamos processos, governança de projetos e disciplinas essenciais (Administração de Dados, QA, SRE, UX) para alinhar a técnica às metas da liderança.',
        icon: GraduationCap,
        image: '/assets/equipe-desenvolvimento-web-design-manutencao-suporte-isometrico-alinhado-esquerda.svg',
    },
]
